import { routeConfig } from '@/components/modules/rule-components/routeConfig'
import type { FormContextType } from '@/routes/rule/instagram.lazy'
import { createFileRoute } from '@tanstack/react-router'
import { createContext } from 'react'

export const Route = createFileRoute('/rule/instagram')(routeConfig())
export const FormContext = createContext<FormContextType>({} as FormContextType) // <--- 留意这个类型
